import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import React from 'react';
import logoClovek from '@/assets/logos/clovek-v-tisni.svg?url';
import logoRubikon from '@/assets/logos/rubikon.png';
import logoPoradna from '@/assets/logos/poradna-pri-financni-tisni.svg?url';
import { SectionHeadline } from '@/components/SectionHeadline';
import { Text } from '@/components/typography';
import EshopBoxes from '@/components/boxes/EshopBox/EshopBoxes';
import { convertList } from '@/sections/forEshops/Integration';
const itemsList = convertList([{
  title: 'Rubikon centrum',
  link: 'https://www.rubikoncentrum.cz/',
  logo: logoRubikon
}, {
  title: 'Člověk v tísni',
  link: 'https://www.clovekvtisni.cz/',
  logo: logoClovek
}, {
  title: 'Poradna při finanční tísni',
  link: 'https://www.financnitisen.cz/',
  logo: logoPoradna
}]);
export function Consulting() {
  const $ = _c(13);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["shopWisely"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("consulting.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <SectionHeadline className="mb-4 lg:mb-6" anchorKey="consulting.title">{t1}</SectionHeadline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("consulting.text");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <Text variant="p2" className="mb-12 text-center text-gray-800 lg:mb-16">{t3}</Text>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <EshopBoxes eshops={itemsList} boxSize="sm" className="mb-8 lg:mb-12" />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t4) {
    t6 = <div className="px-4"><div className="mx-auto max-w-292">{t2}{t4}{t5}</div></div>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}